// extracted by mini-css-extract-plugin
export default {"horizontalScrollContainer":"HorizontalScroll_horizontalScrollContainer__hYfE5","content":"HorizontalScroll_content__o4jyh"};